import { FormControl, Select, MenuItem } from "@mui/material";

export default function SelectControl(props) {
  return (
    <FormControl fullWidth>
      {/* <InputLabel id="label">Input Type</InputLabel> */}
      <Select
        size="small"
        labelId={props.id}
        id={props.id}
        name={props.id}
        value={props.value}
        // label="Row Type"
        onChange={(e) => props.onChange(props.id, e.target.value)}
      >
        {props.options.map((item) => (
          <MenuItem value={item}>{item}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
